var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('List',{ref:"listComponent",attrs:{"headers":_vm.headers,"formview":_vm.formview,"table":_vm.table,"addbutton":false,"default_limit":'500',"default_sort":'pickup_timestamp',"default_sort_typ":'DESC',"filter_clearing":true,"extension":_vm.getExtension(),"export_csv":true},on:{"filterChange":_vm.onFilterChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }